import { BookingTypes } from "../models/Enums";

export const BOOKING_TYPE_UNAVAILABLE = "(No Bookings Available)";
export const REASON_CATEGORY_UNAVAILABLE = "(No Bookings Available)";
export const REASON_UNAVAILABLE = "(No Bookings Available)";
export const REGION_UNAVAILABLE = "(No Bookings Available)";
export const BRANCH_UNAVAILABLE = "(No Bookings Available)";

export const USER_CANCELLED_BOOKING = "USER_CANCELLED_BOOKING";
export const BOOKING_CANCELLED_GOING_BACK = "BOOKING_CANCELLED_GOING_BACK";
export const CANCELLED_DOCUMENTS_NOT_PROVIDED =
  "CANCELLED_DOCUMENTS_NOT_PROVIDED";

export const UPLOAD_DOCS_DISCLAIMER =
  "Even though we are asking for specific supporting documents on this form, SARS may request additional supporting documentation after your booking confirmation and prior to your eBooking appointment because your specific appointment reason may necessitate this. Unfortunately supporting documentation requirements also change on an ongoing basis. You may submit any additional relevant supporting documents electronically before your appointment, through the SARS Online Query System, using your booking case reference number on the SARS website, www.sars.gov.za, where a list of supporting document guides are available. Please note that firearms are not allowed on SARS premises whether it be a SARS branch, Mobile Tax Unit or Pop-up service.";

export const NO_REGION = "NO_REGION";

export const SARS_CONTACT_NUMBER = "";

export const SouthAfricaCountryCode = "ZAF";

export const BRANCH_BOOKING_TYPES = [
  BookingTypes.Mobile.toLowerCase(),
  BookingTypes.PopUp.toLowerCase(),
  BookingTypes.WalkIn.toLowerCase(),
  BookingTypes.VATRegistration.toLowerCase(),
];
export const WALK_IN_TYPES = [
  BookingTypes.WalkIn.toLowerCase(),
  BookingTypes.VATRegistration.toLowerCase(),
];
export const SUB_BRANCH_TYPES = [
  BookingTypes.Mobile.toLowerCase(),
  BookingTypes.PopUp.toLowerCase(),
];
